// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_fk","galleryItem_borderTopRadius":"c-p_fl","galleryItem__image":"c-p_fm"};